import { cn } from '@/lib/cn';
import type { InvestmentStatus } from '@/api/types';
import { STATUS_META } from '@/lib/status';

export function StatusBadge({
  status,
  className,
}: {
  status: InvestmentStatus;
  className?: string;
}) {
  const meta = STATUS_META[status];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap',
        meta.className,
        className,
      )}
    >
      <span
        aria-hidden="true"
        className="h-1.5 w-1.5 shrink-0 rounded-full"
        style={{ background: meta.dot }}
      />
      {meta.label}
    </span>
  );
}

export function GroupBadge({ name, color }: { name: string; color: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-[var(--border)] bg-[var(--surface-2)] px-2 py-0.5 text-[11px] font-medium text-[var(--ink-2)] whitespace-nowrap">
      <span
        aria-hidden="true"
        className="h-1.5 w-1.5 shrink-0 rounded-full"
        style={{ background: color }}
      />
      {name}
    </span>
  );
}
